(function ($) {
  $(function () {
    // Button Functions
    $(".js-content-header").click(function () {
      if ($(this).hasClass("isActive")) {
        return;
      }
      $(this).addClass("isActive");
      $(this).parents(".js-content").find(".js-content-wrapper").slideToggle(300);
    });

    $(".js-content-close").click(function () {
      $(this)
        .parents(".js-content")
        .find(".js-content-header")
        .removeClass("isActive");
      $(this).parents(".js-content").find(".js-content-wrapper").slideToggle(300);
    });

    $(".js-faq-question").click(function () {
      $(this).toggleClass("isActive");
      $(this).next().slideToggle(300);
    });
  });

  // 1つめのボタンのみ押下した状態にする
  var firstButton = $(".js-content-header").eq(0)
  firstButton.addClass("isActive");
  firstButton.parents(".js-content").find(".js-content-wrapper").show();

  // Carousel Settings
  const topCarousel = new Swiper("#js-top-carousel", {
    loop: true,
    speed: 1000,
    spaceBetween: 20,
    slidesPerView: "auto",
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });

  // Carousel Settings
  new Swiper("#voice-carousel", {
    loop: true,
    speed: 1000,
    spaceBetween: 30,
    slidesPerView: "auto",
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });
})(jQuery);

